import { Link } from 'react-router-dom';
import { useDeleteUserMutation, useGetOrganizationsQuery, useGetUsersQuery } from '../app/api';
import { useAuth } from '../features/auth/useAuth';
import {
  AdminScreen,
  ListCount,
  RoleBadge,
  card,
  pillButton,
  primaryButtonStyle,
} from '../features/admin/adminUi';

export default function Users() {
  const { role } = useAuth();
  const isSuper = role === 'super_admin';

  const { data: users } = useGetUsersQuery();
  const { data: orgs } = useGetOrganizationsQuery(undefined, { skip: !isSuper });
  const [deleteUser] = useDeleteUserMutation();

  const orgName = (id: string | null) => (id ? orgs?.items.find((o) => o.id === id)?.name ?? '—' : '—');

  return (
    <AdminScreen title="USERS" subtitle="Members sign in with Google — add them by email">
      <div className="scrl" style={{ overflowY: 'auto', padding: 24, minHeight: 0 }}>
        <div style={{ maxWidth: 760, margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
            <ListCount n={users?.total ?? 0} noun="user" />
            <Link to="/users/new" style={{ ...primaryButtonStyle(true), textDecoration: 'none' }}>
              + New user
            </Link>
          </div>
          {users?.items.map((u) => (
            <div key={u.id} style={{ ...card, marginBottom: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 14, fontWeight: 600 }}>{u.name}</span>
                <RoleBadge role={u.role} />
              </div>
              <div className="mono" style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>
                {u.email}
              </div>
              {isSuper && (
                <div style={{ fontSize: 11, color: 'var(--text-faint)', marginTop: 4 }}>{orgName(u.orgId)}</div>
              )}
              <div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
                <Link to={`/users/${u.id}/edit`} style={{ ...pillButton, textDecoration: 'none' }}>
                  Edit
                </Link>
                {u.role !== 'super_admin' && (
                  <button type="button" style={pillButton} onClick={() => void deleteUser(u.id)}>
                    Remove
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </AdminScreen>
  );
}
